var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "new_landing-edit",
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticStyle: { width: "70%" },
          attrs: { model: _vm.form, "label-width": "120px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "活动名称：", prop: "activityName" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入活动名称" },
                model: {
                  value: _vm.form.activityName,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "activityName", $$v)
                  },
                  expression: "form.activityName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "banner图：", prop: "bannerUrl" } },
            [
              _c(
                "el-upload",
                {
                  staticClass: "upload-demo",
                  attrs: {
                    action: "#",
                    "on-remove": _vm.handleRemoveBannerFile,
                    "file-list": _vm.bannerFileList,
                    "http-request": _vm.handleBannerUpload,
                    "on-preview": _vm.handlePreview,
                    "list-type": "picture-card",
                    "auto-upload": true,
                    accept: "image/*",
                  },
                },
                [_c("i", { staticClass: "el-icon-plus" })]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "upload-tip" }, [
                _vm._v("图片格式：jpg/png，大小≤2MB"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "点餐类型：", prop: "menuTypes" } },
            [
              _c(
                "el-checkbox-group",
                {
                  model: {
                    value: _vm.form.menuTypes,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "menuTypes", $$v)
                    },
                    expression: "form.menuTypes",
                  },
                },
                _vm._l(_vm.menuTypeList, function (item) {
                  return _c(
                    "el-checkbox",
                    { key: item.code, attrs: { label: item.code } },
                    [_vm._v("\n          " + _vm._s(item.desc) + "\n        ")]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "活动时间范围：" } },
            [
              _c("el-date-picker", {
                attrs: {
                  type: "daterange",
                  format: "yyyy-MM-dd",
                  "value-format": "yyyy-MM-dd",
                  "range-separator": "至",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                },
                model: {
                  value: _vm.form.executeDateList,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "executeDateList", $$v)
                  },
                  expression: "form.executeDateList",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "执行时间", prop: "executeTimeList" } },
            [
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c("el-time-picker", {
                    attrs: {
                      "is-range": "",
                      format: "HH:mm",
                      "value-format": "HH:mm",
                      "range-separator": "至",
                      "start-placeholder": "开始时间",
                      "end-placeholder": "结束时间",
                      placeholder: "选择时间范围",
                    },
                    model: {
                      value: _vm.form.executeTimeList,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "executeTimeList", $$v)
                      },
                      expression: "form.executeTimeList",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "关联商品：", prop: "checkedGoodsList" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "70%" },
                  attrs: {
                    filterable: "",
                    remote: "",
                    "reserve-keyword": "",
                    placeholder: "请搜索选项关联商品",
                    "remote-method": _vm.searchGoods,
                    loading: _vm.searchGoodsLoading,
                    "value-key": "goodsFnId",
                  },
                  model: {
                    value: _vm.landingGoods,
                    callback: function ($$v) {
                      _vm.landingGoods = $$v
                    },
                    expression: "landingGoods",
                  },
                },
                _vm._l(_vm.relatedGoodsList, function (item) {
                  return _c(
                    "el-option",
                    {
                      key: item.goodsFnId,
                      attrs: { label: item.goodsName, value: item },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                            "justify-content": "space-between",
                          },
                        },
                        [
                          _c("span", [_vm._v(_vm._s(item.goodsName))]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(item.goodsCode))]),
                        ]
                      ),
                    ]
                  )
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "text" }, on: { click: _vm.addLandingGoods } },
                [_vm._v("\n        添加\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  key: _vm.goodsTableKey,
                  staticStyle: { width: "70%" },
                  attrs: { border: "", data: _vm.form.checkedGoodsList },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "goodsCode", label: "商品编号" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "goodsName", label: "商品名称" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "sorts", label: "商品排序", width: "160" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input-number", {
                              attrs: { min: 0, precision: 0, size: "small" },
                              model: {
                                value: scope.row.sorts,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "sorts", $$v)
                                },
                                expression: "scope.row.sorts",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "80" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeLandingGoods(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n              移除\n            ")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "是否启用：", prop: "status" } },
            [
              _c(
                "el-radio-group",
                {
                  attrs: { size: "small" },
                  model: {
                    value: _vm.form.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "status", $$v)
                    },
                    expression: "form.status",
                  },
                },
                [
                  _c("el-radio-button", { attrs: { label: false } }, [
                    _vm._v("\n          无效\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-radio-button", { attrs: { label: true } }, [
                    _vm._v("\n          有效\n        "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "全部门店：", prop: "storeScope" } },
            [
              _c(
                "el-checkbox",
                {
                  attrs: { "true-label": 0, "false-label": 1 },
                  on: { change: _vm.handleStoreScopeChange },
                  model: {
                    value: _vm.form.storeScope,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "storeScope", $$v)
                    },
                    expression: "form.storeScope",
                  },
                },
                [_vm._v("\n        全部门店\n      ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.form.storeScope === 1
            ? _c(
                "el-form-item",
                { attrs: { label: "指定门店", prop: "relatedStoreIdList" } },
                _vm._l(_vm.regionStoreList, function (regionStore) {
                  return _c("region-store-pane", {
                    key: regionStore.regionId,
                    ref: "regionStorePane_" + regionStore.regionId,
                    refInFor: true,
                    attrs: {
                      "region-store": regionStore,
                      "echo-store-ids": _vm.form.relatedStoreIdList,
                    },
                    on: { change: _vm.handleRegionStoreChange },
                  })
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitForm } },
                [_vm._v("\n        提交\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }